import { useSubmissionVisibility } from "@/hooks/useSubmissionVisibility";
import { ReviewMode, usePlanManagerContext } from "@/providers/PlanManagerProvider";
import ActivityApproveRejectButtons from "./ActivityApproveRejectButtons";
import { ReviewerStatus } from "@/Utils/Plan/PlanSubmisionsTypes";
import { getPlanPermissions } from "@/Utils/getPlanPermissions";

const ActivityFooter = () => {
  const {
    planManager,
    planReviewContextValue: { openReviewModal }
  } = usePlanManagerContext();

  const planSubmission = planManager?.state?.GetPlanSubmission();

  const { canReviewPlans } = getPlanPermissions({ useCurrentPlan: true });
  const { isReviewer, hasActiveSubmission, getCurrentUserReviewStatus } =
    useSubmissionVisibility(planSubmission);

  const enablePlanApprovals = planManager?.state?.GetApprovalSettings()?.enablePlanApprovals;

  if (!enablePlanApprovals || !canReviewPlans || !isReviewer || !hasActiveSubmission) {
    return null;
  }

  const handleApprove = () => {
    openReviewModal(ReviewMode.APPROVE);
  };

  const handleReject = () => {
    openReviewModal(ReviewMode.REJECT);
  };

  return (
    <div className="ocn-activity-footer">
      <ActivityApproveRejectButtons
        reviewerStatus={getCurrentUserReviewStatus() as ReviewerStatus}
        onApprove={handleApprove}
        onReject={handleReject}
        dataTestIdPrefix="activity-footer"
      />
    </div>
  );
};

export default ActivityFooter;
